import React, { useEffect, useState } from "react";
import { useOutletContext } from "react-router-dom";
import "./MyAccountOrderPrescriptionDetails.css";
import * as http from "../../../../utils/http";
import MyAccountOrderPrescriptionDetailsAnswer from "../MyAccountOrderPrescriptionDetailsAnswer";
import * as translator from '../../../../utils/translator';

interface MyAccountOrderPrescriptionDetailsProps{
  hashID: string;
  status: string
  createdAt: string;
  orderPrescriptionDetails: any;
  setOrderPrescriptionDetails: (orderPrescriptionDetails: any) => void;
}

const MyAccountOrderPrescriptionDetails:React.FC<MyAccountOrderPrescriptionDetailsProps> = ({hashID, status, orderPrescriptionDetails, setOrderPrescriptionDetails, createdAt}) => {
  const { language, setRefreshData, setStickyNotificationDetails, customer } = useOutletContext<any>();
  const [isShowAnswerBlock, setIsShowAnswerBlock] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    setOrderPrescriptionDetails(orderPrescriptionDetails)
    setIsShowAnswerBlock(status === 'need_customer_answer')
    setIsLoading(false);
  }, [status])
  
  const getPhoto = (name: string, attachmentID: number) => {
    http
      .postToServer(
        `download-prescription-detail`,
        {
          attachmentID
        },
        [http.MIDDLEWARES.CUSTOMER_ID, http.MIDDLEWARES.GENERATE_FILE]
      )
      .then((response: any) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", name); // replace with desired filename
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      })
      .catch((error) => {
        // Handle error
      });
    };
    
    const onSubmit = (file: { binary_data: ArrayBuffer,filename:string,type:string } | null, message:string) => {
      setIsLoading(true)
      let fileToSend:any = null
      file ? fileToSend = [file] : fileToSend = []
      http
        .postMultiPartsToServer(
          `account-update/prescription-details`,
          {
            message,
            orderID: orderPrescriptionDetails[0].order_id,
            hashID: hashID,
            prescriptionID: orderPrescriptionDetails[0].prescription_id,
            customerID: customer.id,
            createdAt: createdAt
          },
          fileToSend,
          [
            http.MIDDLEWARES.CUSTOMER_ID,
          ]
        )
        .then((response:any) => {
          setRefreshData((current:boolean)=>!current)
        })
        .catch((error) => {
          setStickyNotificationDetails((currentDetails:any) => ({
            show: true,
            title: "",
            content: translator.translate(language, "my_account", `stickyNotifications/error/${error.response.data}`),
            level : "error",
            showInfoIcon:false,
            refresh: !currentDetails.refresh
          }))
        });
    };

  if(orderPrescriptionDetails?.length > 0){
    return (
      <>
        <div className="prescription-details">
          {/* RENDERING MESSAGES ROWS */}
          {orderPrescriptionDetails.map((message: any, index: number) => (
              <div className="prescription-details-message" key={index}>
                <div className="prescription-details-author">
                  <span>
                    {message.first_name} {message.middle_name} {message.last_name}{" "}
                  </span>
                  <span> {message.created_at} </span>
                </div>
    
                <div className="prescription-details-content">
                  <p>{message.content}</p>
                  {/* the following for attachments: */}
                  {message.display_name && (
                    <a onClick={() => getPhoto(message.name, message.attachment_id)}>
                      {message.display_name}
                    </a>
                  )}
                </div>
              </div>
          ))}
          {/* END OF RENDERING MESSAGES ROWS */}

          {
            isShowAnswerBlock && <MyAccountOrderPrescriptionDetailsAnswer onSubmit={onSubmit} isLoading={isLoading}/>
          }

        </div>
      </>
    );
  } else {
    return <></>
  }

  
};

export default MyAccountOrderPrescriptionDetails;
